// Small synthesized UI sounds (no audio files). Visitors can switch them off; the choice is remembered.
const KEY = "757-sfx";
let ctx = null;
let enabled = (() => {
  try {
    return localStorage.getItem(KEY) !== "off";
  } catch {
    return true;
  }
})();

const audio = () => {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    ctx = AC ? new AC() : null;
  }
  if (ctx?.state === "suspended") ctx.resume();
  return ctx;
};

const tone = (freq, at, dur, vol, type = "sine") => {
  const ac = audio();
  if (!ac) return;
  const t = ac.currentTime + at;
  const osc = ac.createOscillator();
  const gain = ac.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t);
  gain.gain.setValueAtTime(0.0001, t);
  gain.gain.exponentialRampToValueAtTime(vol, t + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  osc.connect(gain).connect(ac.destination);
  osc.start(t);
  osc.stop(t + dur + 0.02);
};

export const playClick = () => {
  if (enabled) tone(1250, 0, 0.07, 0.03, "triangle");
};
/** Sparkly 3-note chime for AI moments. */
export const playChime = () => {
  if (!enabled) return;
  [1047, 1319, 1568, 2093].forEach((f, i) => tone(f, i * 0.06, 0.32, 0.028));
};
export const soundsOn = () => enabled;
export const setSounds = (on) => {
  enabled = on;
  try {
    localStorage.setItem(KEY, on ? "on" : "off");
  } catch {
    /* storage blocked: setting lasts for this visit */
  }
  if (on) playClick();
};

/** One listener for the whole site: buttons and links click; elements marked data-sfx="chime" chime. */
export const installClickSounds = () => {
  const onDown = (e) => {
    const el = e.target.closest?.('button, a, [role="button"], [role="tab"], [data-sfx]');
    if (!el || el.closest('[data-sfx="off"]')) return;
    if (el.closest('[data-sfx="chime"]')) playChime();
    else playClick();
  };
  window.addEventListener("pointerdown", onDown, { passive: true });
  return () => window.removeEventListener("pointerdown", onDown);
};
